<template>
  <div class="studio20-layout23">
    <f-form scroll>
      <template #title> <f-icon icon="fa6-clone"></f-icon>{{ $vt('Layouts') }} </template>
      <template #content>
        <div class="studio20-layout23-container">
          <div
            class="studio20-layout23-layout"
            :class="{
              selected:
                component.selected && mode.nid == component.selected.nid,
            }"
            @click="handler.action(mode, 'select')"
            v-for="mode in component.modes"
            :key="mode['#id']"
          >
            <span class="vstudio20-mode-htmlicon" v-html="mode.htmlicon"></span>
          </div>
        </div>
      </template>
    </f-form>
  </div>
</template>
<script>
export default {
  props: {
    component: Object,
    handler: Object,
  },
  translate25Context: 'studio20_layout23',
  // data() {},
  components: {},
  methods: {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang="css" scoped>
.studio20-layout23 >>> form .content-container .content {
  padding: 0;
  margin: 0 16px;
}
</style>
<style lang="scss">
.studio20-layout23 {
  height: 100%;
  form {
    height: 100%;
  }
  .studio20-layout23-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    .studio20-layout23-layout {
      cursor: pointer;
      &:hover {
        .studio20-layout23-layout-layer {
          background: #8C8C8C;
        }
      }

      &.selected {
        .studio20-layout23-layout-layer {
          background: #1E7DAD;
        }
      }
      .studio20-layout23-layout-layer {
        background: #525252;
        color: var(--white-a50);
        border-radius: 3px;
        outline: solid 1px #181919;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>